import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutUomExcludedExceptionSlideout extends Layout {
    labelHeaderRateException: Label;
    panelUOMException: Panel;
    sourceRateExceptionDispatchControl: DataSource;
    tableBrokerageLTLRateExceptions: Table;
}
